import React from "react"
import { default as SlickSlider } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "style/CMSSlider.scss"
import { Container, Image, Button } from "semantic-ui-react"
// import "react-responsive-carousel/lib/styles/carousel.min.css"


export default class CMSSlider extends React.Component {

  state = {
    isDragging: false
  }

  toggleDragging = () =>{ 
    this.setState( { isDragging: !this.state.isDragging } );
  }
  onClickHandler = ( event ) => {
    if ( this.props.isDragging ) {
      event.preventDefault();
    } else {
      return true
    }
  };

  render() {

    const { slidesToShow = 1, autoplaySpeed = 4000, autoplay = true, slidesToScroll = 1, centerMode = false, centerPadding = "0px", dots = true, arrows = false, speed = 500 } = this.props
    const settings = {
      dots,
      infinite: true,
      speed,
      arrows,
      slidesToShow,
      slidesToScroll,
      centerMode,
      centerPadding,
      autoplay,
      autoplaySpeed,

      appendDots: dots => (
      <div style={{ textAlign: "right", paddingRight: "10%", paddingBottom: "6%" }}>
      {dots}
      
      {/*<button 
      style={{
      paddingRight: "10%", 
      paddingBottom: "5%",
      position: "absolute",
      zIndex: 1000,
      background: "transparent",
      border: "none",
      cursor: "pointer",
      backgroundImage: "url('/image/Pfad_451.svg')",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      maxWidth: "10px",
      maxHeight: "10px"
      }}
      onClick={() => this.slider.slickNext()}
      >
      </button> */}
      </div>
      ),
      customPaging: i => (
      <div
      style={{
      width: "15px",
      height: "15px",
      borderRadius: "50%",
      background: "#ccc",
      margin: "0 2px",
      cursor: "pointer",
      border: this.slider && this.slider.innerSlider && this.slider.innerSlider.state && i === this.slider.innerSlider.state.currentSlide ? "3px solid white" : "none"
      }}
      ></div>
      )
    };

    const { isDragging } = this.state
    console.log("SLIDER", this.props.children, isDragging)
    return (
      <React.Fragment>
      <SlickSlider {...settings} 
             className={`CMSSlider${arrows ? '' : ' CMSSlider--no-arrows'}`}
             ref={slider => (this.slider = slider)}
      >
        {React.Children.map(this.props.children, (child, index) => (
        <div onClick={() => {
          if (index === 0) {
            //window.scrollBy({ top: window.innerHeight * 3.5, behavior: 'smooth' });
          }
        }}>
          {child}
        </div>
        ))}
      </SlickSlider>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Slider/Slider.js